/**
 * Constantes de setores de produção
 * 
 * Centraliza os IDs de setores usados no fluxo de produção
 * para evitar valores hardcoded espalhados pelo código.
 */
export const PRODUCTION_SECTORS = {
  /** Setor Arte-Final (origem) */
  ARTE_FINAL: 3,
  /** Próximo setor de produção */
  PRODUCAO: 2,
  /** Próximo setor do orçamento (produção) */
  PRODUCAO_ORCAMENTO: 3,
} as const;

export type ProductionSector = typeof PRODUCTION_SECTORS[keyof typeof PRODUCTION_SECTORS];

